import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';
import {GeneralClairvoyantComponent} from '../g-clairvoyant.component';

@Component({
  selector: 'app-clairvoyant-two-player',
  templateUrl: './clairvoyant-two-player.component.html',
  styleUrls: ['./clairvoyant-two-player.component.css']
})
export class ClairvoyantTwoPlayerComponent extends GeneralClairvoyantComponent {

  readyForClairvoyant = false;
  solution: number;
  clickedValue: number;
  isLeaved: boolean;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
  }

  initValues() {
    super.initValues();
    this.readyForClairvoyant = false;
    this.isLeaved = false;
    this.solution = -1;
  }

  checkSolution() {
    // if solution correct, generate new exercise
    if (this.clickedValue === this.solution) {
      this.solved = true;
      this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
      this.isSolvedImageVisible = true;
      setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
      this.saveState();
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  setClickedValue( solutionNumber: number) {
    // check if solution is correct
    this.clickedValue = solutionNumber;
    this.checkSolution();
  }

  setSolution (counterClosedCards: number) {
    this.solution = counterClosedCards;
  }

  checkReadyForClairvoyant() {
    if (this.solution > 0) {
      this.readyForClairvoyant = true;
    } else {
      this.messageService.addAlertWithTimeout(this.get('turn1card'), 'danger', 2000);
    }
  }

  setLeaveRoom(isLeaved: boolean) {
    this.isLeaved = isLeaved;
  }
}
